import { LoadingContainer, Spinner } from './styled';

export const Loading = ({ message = '', size = 'medium' }) => {
  return (
    <LoadingContainer>
      <Spinner $size={size} />
      {message && <p>{message}</p>}
    </LoadingContainer>
  );
};

